<template lang="pug">
    #app.flex.flex-column.avenir
        #middle.flex.flex-auto
            #map-container.relative.flex-auto
                Map
                //- #overlay.absolute.h-100.w-100
                #geocoder-container.ma2
                About(:open="aboutOpen" @close="aboutOpen=false")
                ShowAbout(@open="aboutOpen=true")
                FeatureInfo
                ShareLink(:open="shareOpen" @close="shareOpen=false")
                Notice
                    //- .debug.w5.h5 {{vh }}

</template>

<script>
import Map from './components/Map.vue';
import FeatureInfo from './components/FeatureInfo.vue';
import Legend from '@/components/Legend.vue';
import About from '@/components/About.vue';
import ShowAbout from '@/components/ShowAbout.vue';
import ShareLink from '@/components/ShareLink.vue';
import Notice from '@/components/Notice.vue';

import { EventBus } from './EventBus';
window.app = {};
export default {
    name: 'app',
    components: {
        Map,
        FeatureInfo,
        Legend,
        About,
        ShareLink,
        ShowAbout,
        Notice,
    },
    data() {
        return {
            aboutOpen: false,
            shareOpen: false,
            vh: 0,
        };
    },
    created() {
        window.app.App = this;

        const updateVh = () => {
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            this.vh = vh;
        };

        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        window.addEventListener('resize', updateVh);
        updateVh();
    },
    watch: {
        aboutOpen() {
            EventBus.$emit('clear-feature');
        },
    },
};

require('tachyons/css/tachyons.min.css');
</script>

<style scoped>
html,
body {
    width: 100%;
    margin: 0;
    padding: 0;
}

#app,
html,
body {
    /* See https://stackoverflow.com/questions/37112218/css3-100vh-not-constant-in-mobile-browser */

    /* min-height: 100vh;
    /* height: calc(var(--vh, 1vh) * 100); */

    min-height: 100vh;
}

@supports (-webkit-touch-callout: none) {
    /* CSS specific to iOS devices */
    #app,
    html,
    body {
        /* Seems to be the best way to get height correct on iOS/Safari but fails on Chrome */
        min-height: -webkit-fill-available;
    }
}

#overlay {
    /* pointer-events: none; */
}
</style>
<style>
@media screen and (min-width: 768px) {
    .only-mobile {
        display: none;
    }
}
@media screen and (max-width: 767px) {
    .not-mobile {
        display: none;
    }
}

@font-face {
    /* font-family: 'DIN W06 Regular'; */
    font-family: 'DIN';
    src: url('assets/Fonts/5591088/9ed03534-f484-47cf-a60b-b0cfd11b7238.woff2')
            format('woff2'),
        url('assets/Fonts/5591088/e3fd9768-3efe-4bc2-9064-6c2dc909b994.woff')
            format('woff');
}
@font-face {
    /* font-family: 'DIN W07 Italic'; */
    font-family: 'DIN';
    font-style: italic;
    src: url('assets/Fonts/5591104/5cf6c537-f9b0-43d7-a616-baefe83631fd.woff2')
            format('woff2'),
        url('assets/Fonts/5591104/08d459fd-6494-4179-ad86-5e145c42f3d0.woff')
            format('woff');
}
@font-face {
    /* font-family: 'DIN W06 Bold'; */
    font-family: 'DIN';
    font-weight: bold;
    src: url('assets/Fonts/5591148/ecf0980a-ae24-4271-ae5d-f538f91dc0eb.woff2')
            format('woff2'),
        url('assets/Fonts/5591148/fcb50c8b-04fc-453b-b49c-227c6dc45e69.woff')
            format('woff');
}
.din {
    font-family: 'DIN';
}
</style>
